import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Redirect from "./Redirect";
import NaverLoginCallback from './Login/NaverLoginCallback';
import LoginPage from "./Login/LoginPage";
import FairytaleV2 from './Fairytale/FairytaleV2.js';
import FairyTail from './FairyTail/FairyTail.js';
import Main from './Main/Main.js';
import Heroes from './Hero/Heroes.js';
import AddHero from './Hero/AddHero.js';
import SettingV2 from './Hero/SettingV2/SettingV2.js';
import Manage from './Manage/Manage.js';
import About from './About/About.js';
import History from './Manage/History.js';
import Script from './Manage/Script.js';
import Summary from './Manage/Summary.js';
import KakaoLoginCallback from './Login/KakaoLoginCallback.js';
import HeroesManage from './Manage/HeroesManage.js';
import HeroManage from './Manage/HeroManage.js';
import StoryManage from './Manage/StoryManage.js';
import ImageUpdate from './Manage/ImageUpdate.js';
import HoldingTasks from './Manage/HoldingTasks.js';
import Maintenance from './Maintenance.js';
import TellingPapaAppBridgeSync from './Utils/TellingPapaAppBridgeSync.js';
import AppList from './AppPayment/AppList.js';
import AppPayment from './AppPayment/AppPayment.js';
import AppProductionList from './AppPayment/AppProductionList.js';
import AppProductionDetail from './AppPayment/AppProductionDetail.js';
import AppPaymentComplete from './AppPayment/AppPaymentComplete.js';
import LegalPage from './Legal/LegalPage.js';
import SupportInquiryList from './SupportInquiry/SupportInquiryList.js';
import SupportInquiryNew from './SupportInquiry/SupportInquiryNew.js';
import SupportInquiryDetail from './SupportInquiry/SupportInquiryDetail.js';
import ManageInquiryList from './SupportInquiry/ManageInquiryList.js';
import ManageInquiryDetail from './SupportInquiry/ManageInquiryDetail.js';
import AppPaymentOrdersManage from './Manage/AppPaymentOrdersManage.js';
import { isLogin } from './Utils/Cookies.js';

const App = (props) => {
  return (
    <BrowserRouter>
      <TellingPapaAppBridgeSync />
      <div className="mx-auto">
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/premium" element={<Redirect url={isLogin() ? "/heroes/add" : "/login?redirect=/heroes/add"} />} />
          <Route path="/apps" element={<AppList />} />
          <Route path="/apps/:appNo/payment" element={<AppPayment />} />
          <Route path="/apps/payment/complete" element={<AppPaymentComplete />} />
          <Route path="/orders" element={<AppProductionList />} />
          <Route path="/orders/:productionNo" element={<AppProductionDetail />} />
          <Route path="/app-productions" element={<AppProductionList />} />
          <Route path="/app-productions/:productionNo" element={<AppProductionDetail />} />
          <Route path="/heroes" element={<Heroes />} />
          <Route path="/fairytales" element={<FairyTail />} />
          <Route path="/fairytales/:code" element={<FairytaleV2 />} />
          <Route path="/heroes/:heroNo/setting" element={<SettingV2 />} />
          <Route path="/heroes/add" element={<AddHero />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<LegalPage documentKey="terms" />} />
          <Route path="/privacy-policy" element={<LegalPage documentKey="privacy" />} />
          <Route path="/support/inquiries" element={<SupportInquiryList />} />
          <Route path="/support/inquiries/new" element={<SupportInquiryNew />} />
          <Route path="/support/inquiries/:inquiryNo" element={<SupportInquiryDetail />} />
          <Route path="/auth/callback/naver" element={<NaverLoginCallback />} />
          <Route path="/auth/callback/kakao" element={<KakaoLoginCallback />} />
          <Route path="/manage" element={<Manage />} />
          <Route path="/manage/history" element={<History />} />
          <Route path="/manage/script" element={<Script />} />
          <Route path="/manage/summary" element={<Summary />} />
          <Route path="/manage/heroes" element={<HeroesManage />} />
          <Route path="/manage/hero" element={<HeroManage />} />
          <Route path="/manage/story" element={<StoryManage />} />
          <Route path="/manage/image-update" element={<ImageUpdate />} />
          <Route path="/manage/holding-tasks" element={<HoldingTasks />} />
          <Route path="/manage/inquiries" element={<ManageInquiryList />} />
          <Route path="/manage/inquiries/:inquiryNo" element={<ManageInquiryDetail />} />
          <Route path="/manage/app-payment-orders" element={<AppPaymentOrdersManage />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="*" element={<Redirect url="/" />} />
        </Routes>
      </div>

    </BrowserRouter >

  );
};
export default App;
